<ng-container *ngIf="appointment">
	<ion-list
		lines="full"
		*ngFor="let section of appointment.dataTab; index as index"
	>
		<ion-item detail="false" button (click)="onClickToggleSection(index)">
			<ion-label>{{ section.heading }}</ion-label>
			<ion-icon
				[name]="
					isVisible(index)
						? 'chevron-up-outline'
						: 'chevron-down-outline'
				"
				slot="end"
			></ion-icon>
		</ion-item>
		<ng-container *ngIf="isVisible(index)">
			<ng-container *ngIf="section.fields.length > 0; else empty">
				<ion-grid>
					<ion-row *ngFor="let field of section.fields; index as i" [ngClass]="(i % 2 == 0) ? 'even' : 'odd'">
						<ng-container *ngIf="field.label; else leftAlign">
							<ion-col size="5" class="ion-text-right">
								<ion-label
									text-wrap
									class="ion-text-wrap bold"
									[innerHTML]="field.label + ':'"
								></ion-label>
							</ion-col>
							<ion-col>
								<ion-text [innerHTML]="field.value"></ion-text>
							</ion-col>
						</ng-container>
						<ng-template #leftAlign>
							<ion-col size="12" size-sm>
								<ion-text [innerHTML]="field.value"></ion-text>
							</ion-col>
						</ng-template>
					</ion-row>
				</ion-grid>
			</ng-container>
			<ng-template #empty>
				<ion-grid>
					<ion-row>
						<ion-col size="6" size-sm>
							<ion-label text-wrap class="ion-text-wrap bold">
								Empty
							</ion-label>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ng-template>
		</ng-container>
	</ion-list>
</ng-container>
